import { render, staticRenderFns } from "./LeaveView.vue?vue&type=template&id=3764b9ca&"
import script from "./LeaveView.vue?vue&type=script&lang=js&"
export * from "./LeaveView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports